<div class="flex flex-col gap-3">
  <div class="flex justify-between">
    <div class="flex flex-col gap-1">
      <div class="text-lg">Total Bonus Payment</div>
      <div class="text-4xl font-bold" *ngIf="selectedBonusEvent.totalBonusAmount; else empty">
        {{ selectedBonusEvent.totalBonusAmount | currencyInPennies: 'USD':'$' }}
      </div>
      <ng-template #empty>
        <div class="text-4xl font-bold">$0</div>
      </ng-template>
    </div>
    <div class="flex flex-col gap-1">
      <div class="text-lg">Subtotal (excl. bonus)</div>
      <div class="text-4xl font-bold" *ngIf="selectedBonusEvent.totalNonBonusAmount; else empty">
        {{ selectedBonusEvent.totalNonBonusAmount | currencyInPennies: 'USD':'$' }}
      </div>
      <ng-template #empty>
        <div class="text-4xl font-bold">$0</div>
      </ng-template>
    </div>
    <div class="flex flex-col gap-1">
      <div class="text-lg">Total cost</div>
      <div class="text-4xl font-bold" *ngIf="selectedBonusEvent.totalOrderAmount; else empty">
        {{ selectedBonusEvent.totalOrderAmount | currencyInPennies: 'USD':'$' | dashIfNothing }}
      </div>
      <ng-template #empty>
        <div class="text-4xl font-bold">$0</div>
      </ng-template>
    </div>
  </div>

  <div class="flex flex-col w-full" *ngIf="selectedBonusEvent.quota">
    <div>Quota</div>
    <div class="font-light">{{ selectedBonusEvent.totalOrderCount }} of {{ selectedBonusEvent.quota }} loads</div>
    <mat-progress-bar
      mode="determinate"
      [value]="(selectedBonusEvent.totalOrderCount / selectedBonusEvent.quota) * 100"
      class="flex-grow rounded-full h-16"
    ></mat-progress-bar>
  </div>

  <div class="flex flex-col w-full" *ngIf="selectedBonusEvent.priceCap">
    <div>Price Cap</div>
    <div class="font-light">
      {{ selectedBonusEvent.totalBonusAmount || 0 | currencyInPennies: 'USD':'$' }} of ${{
        selectedBonusEvent.priceCap / 100
      }}
    </div>
    <mat-progress-bar
      mode="determinate"
      [value]="(selectedBonusEvent.totalBonusAmount / selectedBonusEvent.priceCap) * 100"
      class="flex-grow rounded-full h-16"
    ></mat-progress-bar>
  </div>
</div>
